import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  subAssets: {},
  subAssetDetail: {},
  parrentTotalAssetForBtc: '',
  subTotalAssetForBtc: '',
};
export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUB_USER_ASSET_SUCCESS:
      return { ...state, subAssets: action.data };
    case actionTypes.FETCH_SUB_USER_ASSET_DETAIL_SUCCESS:
      return { ...state, subAssetDetail: action.data };
    case actionTypes.FETCH_PARRENT_TOTAL_ASSET_FOR_BTC_SUCCESS:
      return { ...state, parrentTotalAssetForBtc: action.data };
    case actionTypes.FETCH_SUB_TOTAL_ASSET_FOR_BTC_SUCCESS:
      return { ...state, subTotalAssetForBtc: action.data };
    default:
      return state;
  }
};
